import React, { useRef, useState } from "react";
import cencle from "../images/cancel.png";
import { useDispatch, useSelector } from "react-redux";

import updateToggle from "../redux/todos/thunk/updateToggle";
import updateColor from "../redux/todos/thunk/updateColor";
import deleteTodo from "../redux/todos/thunk/deteleTodo";
import { editbtn, update } from "../redux/todos/actions";
import updateTodo from "../redux/todos/thunk/updateTodo";

export default function CompleteTodo({ todo }) {
  const { text, color, completed, id } = todo;
  const states = useSelector((state) => state);
  console.log(states);
  const dispatch = useDispatch();

  // let state = false;
  // let [state, setState] = useState(false);

  const checked = (todoId) => {
    dispatch(updateToggle(completed, todoId));
  };
  const colorSelect = (color, todoId) => {
    dispatch(updateColor(color, todoId));
  };

  const deleting = (todoId) => {
    dispatch(deleteTodo(todoId));
  };

  return (
    <form>
      <div class="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
        <div
          class={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
            completed && "border-green-500 focus-within:border-green-500"
          }`}
        >
          <input
            type="checkbox"
            class="opacity-0 absolute rounded-full"
            onClick={() => checked(todo.id)}
          />
          {completed && (
            <svg
              class=" fill-current w-3 h-3 text-green-500 pointer-events-none"
              viewBox="0 0 20 20"
            >
              <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
          )}
        </div>

        <div class={`select-none flex-1  `}>
          <p>{text}</p>
        </div>

        <div
          onClick={() => colorSelect("green", id)}
          class={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-green-500 hover:bg-green-500 ${
            color === "green" && "bg-green-500"
          } `}
        ></div>

        <div
          onClick={() => colorSelect("yellow", id)}
          class={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-yellow-500 hover:bg-yellow-500 ${
            color === "yellow" && "bg-yellow-500"
          }`}
        ></div>

        <div
          onClick={() => colorSelect("red", id)}
          class={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-red-500 hover:bg-red-500 ${
            color === "red" && "bg-red-500"
          } `}
        ></div>

        <img
          src={cencle}
          class="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
          alt="Cancel"
          onClick={() => deleting(id)}
        />
      </div>
    </form>
  );
}
